import find from 'lodash/find';
import includes from 'lodash/includes';
import { getWindowObject } from '@eb/feature-detection';
import { AU_LOCALE } from '@eb/intl';
import { trackAnalyticsEvent } from '@eb/site-analytics';

import {
    AUSTRALIA_SNAPSHOT_NAME,
    crazyEggSnapshotNames,
    crazyEggSnapshotTagName,
    crazyEggTagName,
    GLOBAL_SNAPSHOT_NAME,
} from '../constants/analytics';
import {
    LOCALE_WITH_VERSION_2,
    PACKAGE_ONE,
    PACKAGE_TWO,
    PACKAGE_VERSION_1,
    PACKAGE_VERSION_2,
    SCRIPT_CRAZY_EGG,
} from '../constants/main';

// CrazyEgg script
export const loadCrazyEgg = () => {
    const isCELoaded = document.querySelector('#crazy_egg_assortments');
    if (isCELoaded) {
        return;
    }
    const script = document.createElement('script');

    script.src = SCRIPT_CRAZY_EGG;
    script.async = true;
    script.id = crazyEggTagName;

    document.body.appendChild(script);
};

export const verifyCountryCrazyEgg = (locale) => {
    loadCrazyEgg();
    if (locale === AU_LOCALE) {
        setCrazyEggSnapshotName(AUSTRALIA_SNAPSHOT_NAME);
    } else {
        setCrazyEggSnapshotName(GLOBAL_SNAPSHOT_NAME);
    }
};

// Set crazy egg snapshot name
export const setCrazyEggSnapshotName = (countryName) => {
    const isCrazyEggScriptTag = document.getElementById(crazyEggTagName);
    const isSnapshotNameScriptTag = document.getElementsByClassName(
        crazyEggSnapshotTagName,
    );
    const snapshotNameId = isSnapshotNameScriptTag[0];
    const snapshotName = crazyEggSnapshotNames[countryName];
    const htmlScriptContent = `var CE_SNAPSHOT_NAME = "Add CrazyEgg to Assortments - Country ${snapshotName}";`;

    if (isSnapshotNameScriptTag.length === 0) {
        const snapshotNameScript = document.createElement('script');

        // Set the Snapshot name
        snapshotNameScript.classList.add(crazyEggSnapshotTagName);
        snapshotNameScript.innerHTML = htmlScriptContent;
        snapshotNameScript.async = true;
        snapshotNameScript.id = `${countryName}`;

        isCrazyEggScriptTag.parentNode.insertBefore(
            snapshotNameScript,
            isCrazyEggScriptTag,
        );
    } else if (snapshotNameId !== undefined) {
        snapshotNameId.id = countryName;
        snapshotNameId.innerHTML = htmlScriptContent;
    }
};

export const appendFinePrintSignifier = (text, signifier = '*') =>
    `${text}${signifier}`;

export const handleLoadDriftChatbot = (tld, isAuthenticated) => {
    const driftChatbot = getWindowObject('drift');
    const driftChatbotTlds = tld === '.com' || tld === '.ca';
    const loadDriftChatbot =
        driftChatbot && driftChatbotTlds && !isAuthenticated;

    // Only load driftchatbot on .com and .ca [EB-72142]
    if (loadDriftChatbot) {
        // Drift script must be included in template for this to work
        driftChatbot.SNIPPET_VERSION = '0.3.1';
        driftChatbot.load('ezt8kh98s8b9');
    }
};

/**
 * Determine whether the latest version of essentials should be used
 * or the default one.
 *
 * Currently, the new version is only used for an experiment in Australia
 * and only for the essentials package
 *
 * @param  {string} locale Only 'en_AU' uses the new version for the moment
 * @param  {Object[]} packages List of packages to be displayed
 * @returns {Boolean} Whether the new version should be used or not
 */
export const isEssentialsNewVersion = (locale, packages) =>
    LOCALE_WITH_VERSION_2.includes(locale) &&
    Boolean(find(packages, { plan: PACKAGE_ONE, version: PACKAGE_VERSION_2 }));

/**
 * Determine whether the user can update from essentials v1 to essentials v2 base on the
 * assortments availability.
 *
 * Only users on essentials v1 on a locale with a different package composition for essentials v2 are allowed to upgrade.
 *
 */
export const canUpdateEssentialsV2 = ({
    locale,
    assortmentsAvailability = {},
}) => {
    const { current: currentPackage, upgrade } = assortmentsAvailability || {};

    return (
        includes(LOCALE_WITH_VERSION_2, locale) &&
        currentPackage &&
        currentPackage.plan === PACKAGE_ONE &&
        currentPackage.version === PACKAGE_VERSION_1 &&
        Boolean(
            find(upgrade, { plan: PACKAGE_ONE, version: PACKAGE_VERSION_2 }),
        )
    );
};

// To know if Australia locale is active
export const isActiveForAU = (locale) => locale === AU_LOCALE;

export const isPackageProfessional = (assortmentsAvailability = {}) =>
    assortmentsAvailability &&
    assortmentsAvailability.current.plan === PACKAGE_TWO;

export const trackAnalyticsEventAU = ({ action, category, dimensions }) => {
    trackAnalyticsEvent({
        action: action,
        category: category,
        dimensions: { ...dimensions },
    });
};
